@if (isMobileView && showCalculations) {
  <div class="roi-calculator-mobile-header">
    <app-logo [width]="115" />
    <a
      mat-button
      routerLink="/"
      color="primary"
      [disableRipple]="true"
    >
      Close
    </a>
  </div>
}
<div [class.calculator-wrapper]="!isMobileView">
  <div
    class="container"
    [style.max-width.px]="containerMaxWidth"
    [style.padding-left.px]="containerSidePadding"
    [style.padding-right.px]="containerSidePadding"
    [style.padding-top.px]="isMobileView && showCalculations ? mobileViewContainerTopPadding : 0"
  >
    @if (!isMobileView) {
      <h1 class="title">Your Early Pay estimate</h1>
    }
    @if (!isMobileView) {
      <p class="subtitle">See how Early Pay funding can boost cash flow and help you win more projects.</p>
    }

    <div class="card card-main">
      <div class="two-col-grid">
        @if (!isMobileView || !showCalculations) {
          <div class="left-panel">
            <div class="left-panel-content">
              <div class="left-panel-title">
                @if (!isMobileView) {
                  <h2 class="panel-title-light">Tell us a bit about your business</h2>
                } @else {
                  <p class="panel-large-title-light">Get an Early Pay estimate</p>

                  <p class="panel-subtitle-light">
                    See how Early Pay funding can boost cash flow and help you win more projects.
                  </p>
                }
              </div>
              <div class="input-control">
                <div class="label-tooltip-group">
                  <label class="label">What’s the invoice amount?</label>
                </div>
                <app-form-field-input
                  data-test="roi-total-invoice-input"
                  type="currency"
                  [control]="monthlyInvoiceControl"
                  [precision]="0"
                />
              </div>
              <div class="input-control">
                <div class="label-tooltip-group">
                  <label class="label">What’s your business’s annual revenue?</label>
                </div>
                <app-form-field-input
                  data-test="roi-annual-revenue-input"
                  type="currency"
                  [control]="yearlyRevenueControl"
                  [precision]="0"
                />
              </div>
              <div>
                <div class="label-tooltip-group">
                  <label class="label">How many days do you typically wait to get paid?</label>
                </div>
                <div class="payment-days-grid">
                  @for (days of paymentDaysList; track days) {
                    <button
                      data-test="roi-payment-days-button"
                      type="button"
                      class="button"
                      [class.button-default-active]="paymentDays === days"
                      [class.button-outline-dark]="paymentDays !== days"
                      (click)="setPaymentDays(days)"
                    >
                      {{ days }}{{ days === 120 ? '+' : '' }}
                    </button>
                  }
                </div>
              </div>
              <div>
                <div class="label-tooltip-group">
                  <label class="label">How much of the invoice do you want in advance? (%)</label>
                </div>
                <div class="payment-days-grid">
                  @for (amount of advanceAmountList; track amount) {
                    <button
                      data-test="roi-advance-amount-button"
                      type="button"
                      class="button"
                      [class.button-default-active]="advancePercentage === amount"
                      [class.button-outline-dark]="advancePercentage !== amount"
                      (click)="onAdvancePercentageChange(amount)"
                    >
                      {{ amount }}
                    </button>
                  }
                </div>
              </div>
              <button
                mat-button
                class="calculate-button glow-button"
                data-test="roi-calculate-my-estimate-button"
                data-analytics="roi-calculate-my-estimate-button"
                color="primary"
                size="large"
                (click)="showEstimates()"
              >
                <span class="glow-text">Calculate my estimate</span>
              </button>
            </div>
          </div>
        }
        @if (!isMobileView || showCalculations) {
          <div class="right-panel">
            <div class="breakdown-title-container">
              @if (!isMobileView) {
                <h2 class="panel-title">Your breakdown</h2>
              } @else {
                <span class="breakdown-title">Your breakdown</span>
                <span class="breakdown-subtitle">Based on your inputs, here’s your Early Pay estimate.</span>
              }
            </div>
            <div class="chart-section">
              <app-early-pay-platform-calculator-output-card
                data-test="breakdown-cash-advance-section"
                tooltipText="This represents the percentage of your invoice that can be advanced to you upfront through Early Pay. You can select how much cash you'd like to advance."
                tooltipPosition="top"
                [label]="'Net funding amount in 48 hours'"
                [value]="showCalculations ? cashAdvance : null"
                [withIcon]="true"
                [isMonochromatic]="true"
              />
              <app-early-pay-platform-calculator-output-card
                data-test="breakdown-balance-amount-paid-section"
                tooltipPosition="top"
                [tooltipText]="
                  'This is the remaining invoice amount that the general contractor (GC) is expected to pay you after ' +
                  paymentDays +
                  ' days, assuming standard payment terms.'
                "
                [label]="'Balance amount paid in ' + paymentDays + ' days'"
                [value]="showCalculations ? paidWithGc : null"
                [withIcon]="true"
                [isMonochromatic]="true"
              />
              <app-early-pay-platform-calculator-output-card
                data-test="breakdown-total-payout-section"
                tooltipText="This is an estimated total payout based on your inputs. Actual amounts may vary due to adjustments."
                tooltipPosition="top"
                [label]="'Total estimated payout'"
                [value]="showCalculations ? totalPayout : null"
                [withIcon]="true"
                [isMonochromatic]="true"
              />
              <app-early-pay-platform-calculator-output-card
                data-test="breakdown-constrafor-fee-section"
                tooltipText="Constrafor's fee combines a gross invoice rate and a platform fee"
                tooltipPosition="top"
                [label]="'Constrafor’s fee'"
                [value]="showCalculations ? constraforsFee : null"
                [withIcon]="true"
                [isMonochromatic]="true"
              />
              <button
                mat-flat-button
                class="breakdown-button"
                data-test="roi-get-funded-button"
                data-analytics="roi-get-funded-now-button"
                color="primary"
                size="large"
                (click)="onFundedCtaClicked()"
              >
                Get funded now
              </button>
              <button
                mat-stroked-button
                class="breakdown-button"
                data-test="roi-learn-more-button"
                data-analytics="roi-learn-more-button"
                color="primary"
                (click)="onEmailMyEstimatesCtaClicked()"
              >
                Learn more
              </button>
              <button
                mat-button
                class="breakdown-button"
                data-test="roi-get-another-estimate-button"
                data-analytics="roi-get-another-estimate-button"
                color="primary"
                [disableRipple]="true"
                (click)="showCalculations = false"
              >
                Get another estimate
              </button>
              <span class="rating-block">
                <div class="rating-content">
                  <mat-icon class="rating-icon">star_outline</mat-icon>
                  <span>4.9/5 by 3650+ subcontractor customers</span>
                </div>
              </span>
            </div>
            <div class="benefits-title">
              <h2 class="panel-title">More benefits</h2>
            </div>
            <div class="breakdown-list">
              <app-icon-tile
                label="Grow faster"
                text="Take on 2x more projects per quarter."
                iconPath="assets/epp-roi-calculator/1.png"
              />
              <app-icon-tile
                label="Save more"
                text="Up to 15% cheaper than using credit cards or bank lines."
                iconPath="assets/epp-roi-calculator/2.png"
              />
              <app-icon-tile
                label="Increase profit margins"
                text="Improve your margins by 10–15% with smarter cash flow."
                iconPath="assets/epp-roi-calculator/3.png"
              />
            </div>
          </div>
        }
      </div>
    </div>
    @if (!isMobileView || !showCalculations) {
      <app-frame-with-title
        title="Frequently Asked Questions"
        width="100%"
        backgroundColor="transparent"
        [fontSize]="isMobileView ? 30 : 48"
      >
        <app-text-accordion [rows]="faqs" />
      </app-frame-with-title>
    }

    @if (!isMobileView || showCalculations) {
      <section
        class="comparison-section"
        [style.width.px]="comparisonBlockWidth"
        [style.padding-left.px]="comparisonHorizontalPadding"
        [style.padding-right.px]="comparisonHorizontalPadding"
      >
        <h1 class="title-dark">We're better than traditional construction financing</h1>
        <p class="subtitle">But don't just take our word for it, see how we compare.</p>
        <div class="responsive-container">
          <img src="/assets/epp-roi-calculator/comparison-table.svg" />
        </div>
      </section>
    }
  </div>
</div>
